import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitSimUserDetails } from '../../../Services/APIs/scan';
import { postLogDetails } from '../../../Services/APIs/appDetails';

function AboutMeForm({ toggleActive }) {
  const navigate = useNavigate();
  const usertpiData = localStorage.getItem("usertpi");
  const parsedUsertpi = usertpiData ? JSON.parse(usertpiData) : {};
  const uid = parsedUsertpi.usertpi || "";
  const company = localStorage.getItem("company");
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobilePhone: '',
    zipCode: '',
    location: '',
    termsAccepted: false
  });

  // useEffect(() => {
  //   localStorage.setItem("is_form", "true");
  //   setTimeout(() => {
  //     toggleActive();
  //   }, 100); 
  // }, [])

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const values = Object.fromEntries(formData.entries());
    const payload = { ...values, is_form_completed: true, patient_UUID: uid, company}
    postLogDetails({ app: company, payLoad: "submitting form...", uid })
    await submitSimUserDetails(payload).then((res) => {
      if (res.status == 200) {
        localStorage.setItem("is_form", "true");
        setTimeout(() => {
          toggleActive();
        }, 100);
      }
    }).catch((err) => {
      localStorage.setItem("is_form", "true");
      setTimeout(() => {
        toggleActive();
      }, 100);
    })

  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };


  
    return (

      <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>

        <div className='mb-4 pb-3'>
          <h1 className=' text-2xl font-medium tracking-[4%] md:text-4xl'><b>About me</b></h1>
          <p className='text-base font-jost tracking-[4%] md:text-2xl'>Please fill out the form below to get your smile results!</p>
          <hr />
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
            <div style={{ flex: 1 }}>
              <label className='text-base font-jost tracking-[4%] md:text-2xl' htmlFor="first_name">First Name</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
                placeholder="First Name"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginTop: '5px'
                }}
                className='text-base font-jost md:text-2xl'
              />
            </div>
            <div style={{ flex: 1 }}>
              <label className='text-base font-jost md:text-2xl' htmlFor="last_name">Last Name</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
                placeholder="Last Name"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginTop: '5px'
                }}
                className='text-base font-jost md:text-2xl'
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label className='text-base font-jost md:text-2xl' htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Email"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                marginTop: '5px'
              }}
              className='text-base font-jost md:text-2xl'
            />
          </div>

          <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
            <div style={{ flex: 1 }}>
              <label className='text-base font-jost md:text-2xl' htmlFor="phone">Mobile Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="Mobile Phone"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginTop: '5px'
                }}
                className='text-base font-jost md:text-2xl'
              />
            </div>
            <div style={{ flex: 1, display: company === "smileverse" ? "none" : "block" }}>
              <label className='text-base font-jost md:text-2xl' htmlFor="zip">{localStorage.getItem("company") == "bangkoksmile" ? "Postal Code" : "Zip Code"}</label>
              <input
                type="text"
                id="zip"
                name="zip"
                value={formData.zip}
                onChange={handleChange}
                required = {company === "smileverse" ? false : true}
                placeholder={localStorage.getItem("company") == "bangkoksmile" ? "Postal Code" : "Zip Code"}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginTop: '5px',
                  display: company === "smileverse" ? "none" : "block"
                }}
                className='text-base font-jost md:text-2xl'
              />
            </div>
          </div>

          {localStorage.getItem("company") !== "bangkoksmile" && <div style={{ marginBottom: '20px' }}>
            <label className='text-base font-jost md:text-2xl' htmlFor="location">Location</label>
            <select
              id="location"
              name="location"
              value={formData.location}
              onChange={handleChange}
              // required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                marginTop: '5px'
              }}
              className='text-base font-jost md:text-2xl'
            >
              {company === "smileverse" ? (
                <option value="abudhabi">Abu Dhabi</option>
              ) : (
                <>
                  <option value="newYork">New York</option>
                  <option value="losAngeles">Los Angeles</option>
                  <option value="chicago">Chicago</option>
                  <option value="houston">Houston</option>
                </>
              )}
            </select>
          </div>  
          }

          <div style={{ marginBottom: '20px' }}>
            <label className='text-base font-jost md:text-2xl flex items-center'>
              <input
                type="checkbox"
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleChange}
                required
                className='w-5 h-5 md:w-6 md:h-6 mr-2 rounded border-gray-300 text-peri-primary focus:ring-peri-primary cursor-pointer'
                style={{
                  minWidth: '1.25rem',
                  minHeight: '1.25rem',
                  
                }}
              />
              I accept the Terms and Conditions
            </label>
          </div>

          <button
            type="submit"
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              cursor: 'pointer',
              marginTop: '20px',
              width: '100%',
              borderRadius: '4px'
            }}
            className='text-base font-jost md:text-2xl'
          >
            SUBMIT & SEE RESULTS
          </button>
        </form>
      </div>
    );
  


}

export default AboutMeForm;

